The optional hirer ID to receive events from.

By default webhook subscriptions will send events from all hirers the partner has access to.
A non-null `hirerId` indicates that this subscription is filtered to a single hirer.
